import React from 'react';
import './ticket.css';
import Layout from '../components/layout';
import digitalTicket from '../assets/digitalticket.png';

const TicketPage = () => {
  return (
    <Layout>
      <div className="ticket_page">
        <img className="digital_ticket" src={digitalTicket} alt="Digital ticket" />
      </div>
    </Layout>
  );
};

export default TicketPage;
